// Entry point for the build script in your package.json
// Import Turbo
import "@hotwired/turbo-rails"
import "./channels"

// FontAwesome setup
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import {
    faUser,
    faCoffee,
    faCircleInfo,
    faCircleCheck,
    faCircleXmark as faCircleXmarkSolid,
    faClock,
    faEye,
    faEyeSlash,
    faFilePdf,
    faGear,
    faLayerGroup,
    faLink,
    faFileDownload,
    faQuestionCircle as faQuestionCircleSolid,
    faPrint,
    faRotateRight,
    faExclamationTriangle,
    faTrash,
    faArrowRightFromBracket,
    faEllipsisVertical,
    faBan,
    faPlus,
    faDownload
} from '@fortawesome/free-solid-svg-icons';
import {
    faQuestionCircle as faQuestionCircleRegular,
    faCircleXmark as faCircleXmarkRegular
} from '@fortawesome/free-regular-svg-icons';

library.add(
    faUser,
    faCoffee,
    faCircleInfo,
    faCircleCheck,
    faCircleXmarkSolid,
    faClock,
    faEye,
    faEyeSlash,
    faFilePdf,
    faGear,
    faLayerGroup,
    faQuestionCircleSolid,
    faQuestionCircleRegular,
    faLink,
    faFileDownload,
    faPrint,
    faExclamationTriangle,
    faCircleXmarkRegular,
    faRotateRight,
    faTrash,
    faArrowRightFromBracket,
    faEllipsisVertical,
    faBan,
    faPlus,
    faDownload
);

// Watch for DOM changes to convert icons
dom.watch();

// Re-convert icons after Turbo navigation
document.addEventListener('turbo:load', () => {
    dom.i2svg();
});

document.addEventListener('turbo:render', () => {
    dom.i2svg();
});

// Import components
import "./components"


console.log('Envinorma application loaded')
